import { Fragment, useRef, useState, useEffect } from "react";
import { Dialog, Transition } from "@headlessui/react";
import {
  useAppContext,
  SET_INFORMATION_ALERT,
  SET_ERROR_ALERT,
  SET_LOADING,
  REFRESH_DATA
} from "../../../Providers/AppProvider";
import axios from "axios";
import { Config } from "../../../Config";
import { PencilSquareIcon } from "@heroicons/react/24/solid";
import { Tooltip } from "react-tooltip";

export default function PridaniUpravaKategorie({ data, novyZaznam }) {
  const { dispatch } = useAppContext();
  const [open, setOpen] = useState(false);
  const [kategorieData, setKategorieData] = useState({});

  useEffect(() => {
    if (open === true) {
      setKategorieData(data)
      if (novyZaznam === false) {
        setKategorieData(data)
      }
      if (novyZaznam === true) {
        setKategorieData({})
      }
    }
  }, [data, open, novyZaznam]);

  const cancelButtonRef = useRef(null);

  function UpravitKategorii() {
    dispatch({ type: SET_LOADING, payload: true })

    axios
      .post(
        `${Config.ServerURL}/api/Vozidla/UpravaKatNakladu`,
        kategorieData,
        {
          withCredentials: true,
        }
      )
      .then((res) => {
        if (res.data.message) {
          dispatch({ type: SET_INFORMATION_ALERT, payload: res.data.message });
        }
        setOpen(false);
        dispatch({ type: REFRESH_DATA })
        dispatch({ type: SET_LOADING, payload: false })
      })
      .catch((err) => {
        dispatch({ type: SET_ERROR_ALERT, payload: err.response.data.message });
        dispatch({ type: SET_LOADING, payload: false })
      });
  }

  function PridatKategorii() {
    dispatch({ type: SET_LOADING, payload: true })

    axios
      .post(
        `${Config.ServerURL}/api/Vozidla/PridaniKatNakladu`,
        kategorieData,
        {
          withCredentials: true,
        }
      )
      .then((res) => {
        if (res.data.message) {
          dispatch({ type: SET_INFORMATION_ALERT, payload: res.data.message });
        }
        dispatch({ type: REFRESH_DATA })
        setOpen(false);
        dispatch({ type: SET_LOADING, payload: false })
      })
      .catch((err) => {
        dispatch({ type: SET_ERROR_ALERT, payload: err.response.data.message });
        dispatch({ type: SET_LOADING, payload: false })
      });
  }

  return (
    <>
      <Transition.Root show={open} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-20"
          initialFocus={cancelButtonRef}
          onClose={setOpen}
        >
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="dialog-transition" />
          </Transition.Child>

          <div className="fixed inset-0 z-20 overflow-y-auto">
            <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <Dialog.Panel className="dialog-edit-ramecek sm:max-w-3xl">
                  <div className="dialog-edit-obsah">
                  <Dialog.Title as="h3" className="dialog-edit-nadpis-velky">
                  {novyZaznam === true && ("Přidání kategorie provozních nákladů:")}
                  {novyZaznam === false && ("Oprava kategorie provozních nákladů:")}
                  </Dialog.Title>

                    <div className="grid grid-cols-6 gap-3">
                      <div className="col-span-6 sm:col-span-2">
                        <label className="dialog-edit-pole-popis">
                        Název kategorie
                        </label>
                        <input
                          value={kategorieData.nazevKategorie || ""}
                          onChange={(e) =>
                            setKategorieData({
                              ...kategorieData,
                              nazevKategorie: e.target.value,
                            })
                          }
                          className="admin-dialog-edit-pole-input"
                        ></input>
                      </div>
                      <div className="col-span-6 sm:col-span-2">
                        <label className="dialog-edit-pole-popis">
                          Zkratka
                        </label>
                        <input
                          value={kategorieData.zkrNazevKat || ""}
                          onChange={(e) =>
                            setKategorieData({
                              ...kategorieData,
                              zkrNazevKat: e.target.value,
                            })
                          }
                          className="admin-dialog-edit-pole-input"
                        ></input>
                      </div>
                      <div className="col-span-6 sm:col-span-2">
                        <label className="dialog-edit-pole-popis">
                          Jednotka množství
                        </label>
                        <input
                          value={kategorieData.jednotkaMnozstvi || ""}
                          onChange={(e) =>
                            setKategorieData({
                              ...kategorieData,
                              jednotkaMnozstvi: e.target.value,
                            })
                          }
                          className="admin-dialog-edit-pole-input"
                        ></input>
                      </div>
                      {/* LA 23.2.23 - editace PopisNakladuVzor */}
                      <div className="col-span-6 sm:col-span-6">
                        <label className="dialog-edit-pole-popis">
                          Vzor popisu nákladů (předvyplní popis nákladů)
                        </label>
                        <input
                          value={kategorieData.popisNakladuVzor || ""}
                          onChange={(e) =>
                            setKategorieData({
                              ...kategorieData,
                              popisNakladuVzor: e.target.value,
                            })
                          }
                          className="admin-dialog-edit-pole-input"
                        ></input>
                      </div>

                      <div className="col-span-6 sm:col-span-2 flex content-center">
                        <label className="dialog-edit-checkbox-popis">
                          Povinné množství
                        </label>
                        <input
                          checked={kategorieData.povinneMnozstvi || false}
                          type="checkbox"
                          onChange={(e) =>
                            setKategorieData({
                              ...kategorieData,
                              povinneMnozstvi: e.target.checked,
                            })
                          }
                          className="admin-dialog-edit-pole-checkbox"
                        ></input>
                      </div>

                      <div className="col-span-6 sm:col-span-2 flex content-center">
                        <label className="dialog-edit-checkbox-popis">
                          Povinný stav tachometru
                        </label>
                        <input
                          checked={kategorieData.povinnyStavTachometru || false}
                          type="checkbox"
                          onChange={(e) =>
                            setKategorieData({
                              ...kategorieData,
                              povinnyStavTachometru: e.target.checked,
                            })
                          }
                          className="admin-dialog-edit-pole-checkbox"
                        ></input>
                      </div>

                      {/* --- Editace Skupiny pro výpočty v přehledech --- */}
                      <div className="col-span-6 sm:col-span-6">
                        <label className="dialog-edit-pole-popis">
                          Skupina pro výpočty v přehledech
                        </label>
                        <select value={kategorieData.pnSkupinaVypocty} onChange={(e) => setKategorieData({...kategorieData, pnSkupinaVypocty: e.target.value, })}
                            className="admin-dialog-edit-pole-select">
                            <option value="0">Vyberte skupinu ...</option>
                            <option value="1">Pohonné hmoty</option>
                            <option value="2">Opravy</option>
                            <option value="3">Údržba</option>
                            <option value="4">Ostatní</option>
                        </select>
                      </div>

                    </div>
                  </div>

                  {/* Tlačítka */}
                  <div className="dialog-edit-zapati-pozadi">
                    {novyZaznam === false &&
                      (<button
                        type="button"
                        className="admin-dialog-edit-tlacitko-akce"
                        onClick={() => UpravitKategorii()}
                      >
                        Uložit
                      </button>)}
                    {novyZaznam === true &&
                      (
                        <button
                          type="button"
                              className="admin-dialog-edit-tlacitko-akce"
                          onClick={() => PridatKategorii()}
                        >
                          Přidat
                        </button>
                      )}
                    <button
                      type="button"
                      className="admin-dialog-edit-tlacitko-zavrit"
                      onClick={() => setOpen(false)}
                      ref={cancelButtonRef}
                    >
                      Zrušit
                    </button>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition.Root>
      {novyZaznam === false &&
        (<div 
          data-tooltip-id="oprava-katnakl-tooltip" 
          data-tooltip-content="Oprava kategorie"
          data-tooltip-delay-show={Config.ToolTipAutoRefreshTime1} data-tooltip-variant="info" 
          onClick={() => setOpen(true)}
          className="admin-dialog-edit-ikona-oprava"
        >
          <span className="sr-only">Otevřit menu úprav</span>
          <PencilSquareIcon className="ikonka-velikostS" aria-hidden="true" />
          <Tooltip id="oprava-katnakl-tooltip" />
        </div>)}
      {novyZaznam === true && (
        <div
          onClick={() => setOpen(true)}
          className={`admin-dialog-tlacitko-akce`}
        >
          Přidat kategorii
        </div>
      )}
    </>
  );
}
